<template>
  <div class="registerArea">
    <v-window v-model="windowHandler" touchless>
      <v-window-item :value="0">
        <div class="register" v-if="windowHandler == 0">
          <p class="titleRegister">
            {{ $t('matchMaking.registerForm.registerByEmail') }}
          </p>
          <v-form ref="signupform" @keypress.enter="register" @submit.prevent="register" @keyup.native.enter="register">
            <v-text-field
                :loader-height="0"
                :label="$t('emailLabel')" v-model="email" :rules="emailRules"
                          prepend-inner-icon="mdi-email-outline"></v-text-field>
            <div class="ltrInput">
              <v-text-field
                  :loader-height="0"
                  dir="ltr"
                  :label="this.$t('phoneLabel')"
                  v-model="phone"
                  :rules="phoneRules"
                  prepend-inner-icon="mdi-cellphone"
                  placeholder="example : +15551234567"
              ></v-text-field>
            </div>
            <v-text-field
                :loader-height="0"
                v-model="password"
                :rules="passwordRules"
                :label="$t('passwordLabel')"
                prepend-inner-icon="mdi-lock"
                :type="showPassword ? 'password' : 'text'"
                :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye'"
                @click:append="showPassword = !showPassword"
            >
            </v-text-field>
            <v-text-field
                :loader-height="0"
                v-model="confirmPassword"
                :rules="passwordRules"
                :label="$t('passwordConfirmationLabel')"
                prepend-inner-icon="mdi-lock"
                :type="showRePassword ? 'password' : 'text'"
                :append-icon="showRePassword ? 'mdi-eye-outline' : 'mdi-eye'"
                @click:append="showRePassword = !showRePassword"
            >
            </v-text-field>
            <v-btn class="registerBtn" color="#4576d8" elevation="0" @click="register">
              {{ $t('signUpLabel') }}
            </v-btn>
            <v-btn class="googleBtn" elevation="0" @click="loginBy('google')">
              <img src="../../assets/matchMaking/google.svg" alt="">
              {{ $t('matchMaking.registerForm.registerByGoogle') }}
            </v-btn>
            <v-btn text color="primary" class="mt-2" @click="windowHandler = 1" id="GoToLoginBtn">
              {{ $t('signupComponent.loginLabel') }}
            </v-btn>
          </v-form>
        </div>
      </v-window-item>
      <v-window-item :value="1">
        <div class="login" v-if="windowHandler == 1">
          <v-form ref="signupform" @keypress.enter="login" @submit.prevent="login" @keyup.native.enter="login">
            <v-text-field
                :loader-height="0"
                :label="$t('loginComponent.form[0]')"
                v-model="email"
                :rules="emailRules"
                id="email_login"
                prepend-inner-icon="mdi-email-outline">
            </v-text-field>
            <v-text-field
                :loader-height="0"
                v-model="password"
                :rules="passwordRules"
                id="password_login"
                :label="$t('loginComponent.form[1]')"
                prepend-inner-icon="mdi-lock"
                :type="showPassword ? 'password' : 'text'"
                :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye'"
                @click:append="showPassword = !showPassword"
            >
            </v-text-field>
          </v-form>
          <v-btn class="registerBtn loginBtn" color="#4576d8" elevation="0" @click="login">
            {{ $t('loginLabel') }}
          </v-btn>
          <div></div>
          <v-btn text color="primary" class="" @click="windowHandler = 0">
            {{ $t('dontHaveAccount') }}
          </v-btn>
        </div>
      </v-window-item>
    </v-window>

  </div>
</template>

<script>
/*eslint-disable*/
import {AsYouType, parsePhoneNumberFromString} from "libphonenumber-js";
import {EventBus} from "@/event-bus";
import {noRedirectPages} from "../../../Lib/utilities";
import EventsMixins from "@/mixins/EventsMixins";
import AuthMixins from "@/mixins/AuthMixins";

export default {
  mixins: [EventsMixins,AuthMixins],
  data() {
    return {
      showPassword: true,
      phone: null,
      showRePassword: true,
      confirmPassword: null,
      email: null,
      password: null,
      windowHandler: 0
    }
  },
  methods: {
    register() {
      this.validating = true;
      if (this.$refs.signupform.validate()) {
        // let phone = this.selectedCountry.code + this.phone.replace(' ', '');
        let phone = this.phone.replaceAll(' ', '');
        const phoneNumber = parsePhoneNumberFromString(phone);
        if (phoneNumber) {
          if (!phoneNumber.isValid()) {
            this.$emitEvent('notify', 'red', undefined, this.$t('Notify.signupComponent.phoneNumberError'));
            return;
          }
        } else {
          this.$emitEvent('notify', 'red', undefined, this.$t('Notify.signupComponent.phoneNumberError'));
          return;
        }
        if (this.confirmPassword === this.password) {
          let newUser = {
            email: this.email,
            password: this.password,
            password_confirmation: this.confirmPassword,
            mobile: phoneNumber.number,
          };
          // if(this.$router.curren tRoute.name == 'preorder') localStorage.setItem('preorder', this.$route.params.orderId);
          this.$emitEvent('setLoading', true);
          this.btnLoading = true;
          this.requesting('auth', 'register', '', newUser).then((data) => {
            let payload = {
              user: {
                email: this.email,
                password: this.password
              },
              header: {
                'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
              }
            }
            this.requesting('auth', 'login', '', payload.user, payload.header).then(() => {
              this.$emitEvent('notify', {
                color: 'green',
                title: this.$t('Notify.signupComponent.success'),
                id: this.GASignup
              });
              this.requesting('auth', 'getProfile').then(() => {
                this.$store.commit('setLoggedIn');
                this.$emitEvent('userLoggedIn');
                this.$store.dispatch('removeInviter');
                this.$emit('successfullyRegistered');
                if (noRedirectPages.includes(this.$router.currentRoute.name)) {
                  this.$emit('userLoggedInAfterRegister', newUser);
                } else {
                  this.$store.commit('setSnackbar', {show: true, type: 'checkEmail'});
                }
                this.WebengageUserRegister(this.$store.getters.getUserInfo.id, this.registered_on, this.mutableEmail, phoneNumber.number)
                this.$emit('sendProfileData')
                this.$emit('afterLogin')
                // this.$router.push({name: "preorder", params: {orderId: 68}})
              })
            })
          }).catch((err) => {
            this.btnLoading = false;
            // console.log('sign up err', err);
            if (err.response.status) {
              this.registerErr = {
                show: true,
                msg: this.$t('Notify.signupComponent.emailError')
              }
            }
            // else if (500 <= err.response.s < 600) {
            //     this.$store.commit('setSnackbar', {show: true, type: 'err500'});
            // }
          }).finally(() => {
            this.btnLoading = false;
            EventBus.$emit('setLoading', false);
          })
        } else if (this.confirmPassword !== this.password) {
          this.registerErr = {
            show: true,
            msg: this.$t('Notify.signupComponent.passwordError')
          }
        }
      } else {
        return;
      }

    },
    login() {
      if (this.$refs.signupform.validate()) {
        let payload = {
          user: {
            email: this.email,
            password: this.password
          },
          header: {
            'X-user-matchmaking-token': localStorage.getItem('user_token_matchMaking')
          }
        }
        this.loginDisabled = true;
        this.$emitEvent('setLoading', true);
        this.requesting('auth', 'login', '', payload.user, payload.header).then((resp) => {
          this.requesting('auth', 'getProfile').then(() => {
            //WebEngage
            this.WebengageSetUserLoggedIn(this.$store.getters.getUserInfo.id)
            let notRedirect = noRedirectPages;
            this.$emitEvent('notify', {
              color: 'green', title: this.$t('Notify.loginSuccess'), id: this.GALogin
            });
            this.$emit('sendProfileData')
            // this.$router.push({name: "preorder", params: {orderId: 68}})
            this.$emit('afterLogin')
          }).finally(() => {
            this.loginDisabled = false;
          })
        }).catch((err) => {
          this.loginDisabled = false;
        }).finally(() => {
          this.$emitEvent('setLoading', false);
        });
      }
    }
    ,

  },
  computed: {},
  watch: {
    phone() {
      if (this.phone.startsWith('00')) {
        this.phone = this.phone.substr(2);
        this.phone = '+' + this.phone;
      }

      if (this.phone.startsWith('098')) {
        this.phone = this.phone.substr(1);
        this.phone = '+' + this.phone;
      }

      if (this.phone.startsWith('09')) {
        this.phone = this.phone.substr(1);
        this.phone = '+98' + this.phone;
      }

      this.phone = new AsYouType().input(this.phone);
    }

  },
}
</script>

<style scoped>
.registerImage {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 400px;
  height: 100%;
  left: 0px;
}

.titleRegister {
  color: #6d5aac;
  font-size: 17px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.41;
  letter-spacing: normal;
}

@media (min-width: 200px ) and (max-width: 600px) {
  .confirmBtn {
    width: 100px !important;
  }

  .registerArea {
    width: 100% !important;
    margin: 0px 0px !important;
    padding: 0px 10px 0px 10px;
  }
}

.confirmBtn {
  width: 268px;
  height: 50px !important;
  padding: 10px 118px !important;
  border-radius: 10px !important;
  margin: 20px auto;
  color: white !important;
  font-size: 17px !important;
  font-weight: 500 !important;
}


.registerArea {
  width: 400px;
  margin: 0px 100px;
}

.registerBtn {
  width: 268px;
  height: 50px !important;
  border-radius: 10px !important;
  margin: 20px auto;
  color: white !important;
  font-size: 17px !important;
  font-weight: 500 !important;
}
</style>